import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CouponForm from "./CouponsForm";
import { getCouponById, editCoupon } from "../../api/couponService";

export default function EditCoupon() {
  const location = useLocation();
  const id = location?.state?.couponId;

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      const res = await getCouponById(id);
      setData(res || {});
    };

    load();
  }, [id]);

  const handleUpdate = async (payload) => {
    setLoading(true);

    try {
      const res = await editCoupon(id, payload);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return (
    <CouponForm
      onSubmit={handleUpdate}
      loading={loading}
      isEdit={true}
      initialData={data}
    />
  );
}
